import React, {useEffect, useState } from 'react'
import Select from 'react-select'
import Mensagem from '../components/Mensagem'
import { obterTodasComStatusCadastrada } from '../services/DenunciaServico'
import RenderizarDenuncia from '../components/RenderizarDenuncia'
import { obterPorProtocolo, obterComplementos } from '../services/DenunciaServico'
import { InputGroup, FormControl, Button, Spinner } from "react-bootstrap"

export default function VisualizarProvidencias(props) {

    const [mensagem, setMensagem] = useState('') 
    const [protocolo, setProtocolo]  = useState('') 
    const [listaProtocolos, setListaProtocolos] = useState([]) 
    const [listaDenuncias, setListaDenuncias] = useState([])
    const [showAguarde, setShowAguarde] = useState(false)

    useEffect(() => {
        obterTodasComStatusCadastrada()
        .then( denuncias => {
            setListaDenuncias(denuncias)
            const protocolos = []
            for (let i=0; i<denuncias.length; i++) {
                let denuncia = denuncias[i]
                protocolos.push({ value:denuncia.protocolo, label:denuncia.protocolo })
            }
            setListaProtocolos(protocolos)
        })
        .catch( erroObterTodasComStatusCadastrada => {
            setMensagem(erroObterTodasComStatusCadastrada)
        })
    }, [props.preencherLista])

    const buscarPeloProtocolo = numeroDoProtocolo => {
        if (showAguarde) {
            return
        }

        setMensagem({ tipo:'LIMPAR', texto:'' })
        setShowAguarde(true)
        let foiEncontrado = false
        for (let i=0; i<listaDenuncias.length; i++) {
            let denuncia = listaDenuncias[i] 
            if (denuncia.protocolo === numeroDoProtocolo) {
                props.setComplementacao(denuncia.protocolo) 
                props.setRenderizarDenuncia({ denuncia, show:true })
                props.showFormulario('VisualizarProvidencias',false,false)
                setShowAguarde(false)
                foiEncontrado = true
            }         
        }

        if (!foiEncontrado) {
            setMensagem({ tipo:'problema', texto:'Denúncia não se encontra cadastrada!' })
            setShowAguarde(false)
        }
    }

    if (!props.linhaDoTempo) {
        return null;
    }
    if (props.linhaDoTempo.emPauta !== "visualizarProvidencias") {
        return null;
    }

    if (props.renderizarDenuncia.show) {
        return(
            <RenderizarDenuncia 
                usuarioLogado={ props.usuarioLogado } 
                renderizarDenuncia={ props.renderizarDenuncia }
                setRenderizarDenuncia={ props.setRenderizarDenuncia } 
            /> 
        )
    }

    const renderListaProtocolos = () => {
        if (!listaProtocolos) {
            return null
        }

        return (
            listaProtocolos.map(item => {
                 return { value: item.value, label: item.label }
            })
        )
    }

    if (props.usuarioLogado.logado) {
        return (
            <div className="molduraSelecionarDenuncias">
                <div className="card" style={{ width:480 }}>
                    <div className="card-header"></div>
                    <div className="card-body">
                        <label>Denúncias:</label>
                        <div className="d-flex align-items-center">
                            <div style={{ width: 300 }}>
                                <Select  
                                    key="keyDenunciasCadastradas"
                                    placeholder="Selecione um nº de protocolo..."
                                    options={ renderListaProtocolos() }
                                    onChange={ item => buscarPeloProtocolo(item.value) }
                                >
                                </Select>
                            </div>
                            <div className={ "ml-2 " + (showAguarde? 'd-block' : 'd-none') }>
                                <Button variant="primary" disabled>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span className="ml-2">Aguarde...</span>
                                </Button>{' '}
                            </div>
                        </div>            
                    </div> 
                </div>
            </div>
        )
    }

    const obterBotaoVisualizar = () => {
        if (showAguarde) {
            return (
                <Button variant="primary" disabled>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    Aguarde...
                </Button>
            )
        }

        return (
            <Button variant="outline-primary" onClick={ () => buscarPeloProtocolo(protocolo) }>
                Visualizar
            </Button>
        )
    }

    return(
        <div className="molduraLeituraProtocolo">
            <Mensagem mensagem={ mensagem } />
            <br />
            <fieldset className="border p-4" style={{ width:480 }}>
                <InputGroup>
                    <FormControl 
                        id="idFormProvidenciasBuscaPeloProtocolo"
                        name="providenciasbuscapeloprotocolo"
                        type="text" 
                        placeholder="Número do Protocolo" 
                        className="mr-sm-2"
                        value={ protocolo }
                        onChange={ event => setProtocolo(event.target.value) }
                    />
                    { obterBotaoVisualizar() }
                </InputGroup>
            </fieldset>
        </div>
    )
}